import { AmplifyPost } from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import { logger } from "providers/logger";

const sendCustomerAppDownloadEmail = async (
  jwt: string,
  prospectId: string
) => {
  return await AmplifyPost(
    "Send Customer App Download Email",
    "OfferExpApi",
    `/prospect/${prospectId}/sendCustomerDownloadEmail`,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    },
    logger
  );
};

export { sendCustomerAppDownloadEmail };
